const portofolioKeywords = [
  {
    name: "Fullstack",
    value: "fullstack",
  },
  {
    name: "Nuxt.js",
    value: "nuxt.js",
  },
  {
    name: "All",
    value: "all",
  },
  {
    name: "Vue.js",
    value: "vue.js",
  },
  {
    name: "React.js",
    value: "react.js",
  },
  {
    name: "Laravel",
    value: "laravel",
  },
  {
    name: "PHP",
    value: "php",
  },
  {
    name: "MySQL",
    value: "mysql",
  },
  {
    name: "MongoDB",
    value: "mongodb",
  },
  {
    name: "Express.js",
    value: "express.js",
  },
  {
    name: "Firebase",
    value: "firebase",
  },
  {
    name: "AWS",
    value: "aws",
  },
  {
    name: "Responsive Web App",
    value: "responsive web app",
  },
];

export { portofolioKeywords };
